import { map, omit, concat } from 'lodash'
import { http, queryString } from 'utils'
import { makeResource, mapped } from '@codium/codium-vue'

import { SET_TIMELINE, ADD_TIMELINE,  SET_TIMELINE_PAGE, SET_TIMELINE_END } from 'vx/mutations'


const actions = {
  getClientTimeline({ commit, state }, { id, payload }) {

    // Always start from the first page as the timeline state is shared between clients
    let page = 1
    commit(SET_TIMELINE, [])
    commit(SET_TIMELINE_END, false)

    return http.get(`clients/${id}/timeline?${queryString(payload)}&page=${page}`).then(response => {
       commit(SET_TIMELINE, response.data.data)

       if (response.data.data.length == 0) {
        commit(SET_TIMELINE_END, true)
       } else {
        commit(SET_TIMELINE_PAGE, page)
       }

       return response
     })
  },
  appendClientTimeline({ commit, state }, { id, payload }) {

    if (state.endTimeline) {
      return Promise.reject('End of timeline.')
    }

    let page = state.timelinePage + 1

    return http.get(`clients/${id}/timeline?${queryString(payload)}&page=${page}`).then(response => {
       commit(ADD_TIMELINE, response.data.data)

       if (response.data.data.length == 0) {
        commit(SET_TIMELINE_END, true)
       } else {
        commit(SET_TIMELINE_PAGE, page)
       }

       return response
     })
  }
}

const state = {
  timeline: [],
  timelinePage: 0,
  endTimeline: false
}

const mutations = {
  [SET_TIMELINE] (state, data) {
    state.timeline = data
  },
  [SET_TIMELINE_PAGE] (state, data) {
    state.timelinePage = data
  },
  [SET_TIMELINE_END] (state, data) {
    state.endTimeline = data
  },
  [ADD_TIMELINE] (state, timeline) {
    state.timeline = concat(state.timeline, timeline)
  }
}

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('clients', {
  storeModule: {
    actions,
    state,
    mutations
  },
  resource () {
    return {
      id: mapped(null),
      firstname: mapped(null),
      surname: mapped(null),
      company: mapped(null),
      email: mapped(null),
      phone: mapped(null),
      mobile: mapped(null)
    }
  }
})
